const getBaseURL = () => {
  if (typeof window !== "undefined") {
    const host = window.location.host;

    if (host.includes("tiiny.host")) {
      return "https://api.tiiny.host/";
    } else if (host.startsWith("preview.tiiny.co.uk")) {
      return "https://preview-api.tiiny.co.uk/";
    } else if (host.startsWith("www.tiiny.co.uk")) {
      return "https://api.tiiny.co.uk/";
    } else if (host.startsWith("localhost")) {
      return "http://localhost:8000/";
    }
  }

  return "https://api.tiiny.host/";
};

const baseUrl = getBaseURL();

export default baseUrl;